import React, { useState } from "react";
import Faq from "./FAQ"; // Імпортуємо компонент Faq
import styles from "./FAQBlock.module.scss";

interface FaqData {
  question: string;
  answer: string;
}

interface FaqBlockProps {
  faqData: FaqData[]; // Передаємо дані через пропс
  title: string; // Передаємо заголовок для блоку питань
}

const FaqBlock: React.FC<FaqBlockProps> = ({ faqData, title }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null); // Стан для збереження відкритого питання

  const handleToggle = (index: number) => {
    // Якщо клікнули на відкрите питання, закриваємо його, інакше відкриваємо нове
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="container">
      <div
        className={`sectionContainer sectionContainerWhite bigSection top12`}
      >
        <div className="sectionTitle sideP64">
          <h2 className={`w64 ${styles.title}`}>{title}</h2>
        </div>
        <div className={`${styles.faqSectionBlock} sideP64`}>
          {faqData.map((faq, index) => (
            <Faq
              key={index}
              question={faq.question}
              answer={faq.answer}
              number={index + 1}
              isOpen={openIndex === index} // Передаємо чи питання відкрите
              onToggle={() => handleToggle(index)} // Передаємо функцію для відкриття/закриття
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FaqBlock;
